<fury-page-layout mode="card">
    <fury-page-layout-header>
      <div class="top_heading">
      <fury-breadcrumbs [@fadeInRight]  current="Lead Partners"></fury-breadcrumbs>
      <div class="daterange">
        <mat-form-field class="example-form-field" appearance="outline">
        <mat-label>Date Range</mat-label>
            <mat-date-range-input
            [formGroup]="dateRangePickerForm"
            [rangePicker]="campaignOnePicker"
            [max]="today" (click)="campaignOnePicker.open()">
            <input matStartDate placeholder="Start date" formControlName="start" #dateRangeStart>
            <input matEndDate placeholder="End date" formControlName="end" #dateRangeEnd>
            </mat-date-range-input>
            <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
            <mat-datepicker-toggle matIconSuffix [for]="campaignOnePicker"></mat-datepicker-toggle>
            <mat-date-range-picker #campaignOnePicker>
                <mat-date-range-picker-actions>
                    <button class="apply" mat-raised-button color="primary" matDateRangePickerApply (click)="dateRangeChangeHandle(dateRangeStart, dateRangeEnd)">Apply</button>
                    <button class="can" mat-button matDateRangePickerCancel (click)="clearDaterangePicker()">Clear</button>
                </mat-date-range-picker-actions>
            </mat-date-range-picker>
            <mat-error *ngIf="dateRangePickerForm.controls['start'].touched && dateRangePickerForm.controls['start'].value && !dateRangePickerForm.controls['end'].value">Please select end date</mat-error>
        </mat-form-field>
    </div>
      </div>
    </fury-page-layout-header>

    <ul class="listcont">
      <li>
        TOTAL LEADS
          <span class="green">{{partnerDashboardData?.totalLeads | number}}</span>
      </li>
      <li>
        TOTAL GOOD LEADS
          <span class="orenge">{{partnerDashboardData?.totalGoodLeads | number}}</span>
      </li>
      <li>
        TOTAL BAD LEADS
          <span class="red">{{partnerDashboardData?.totalBadLeads | number}}</span>
      </li>
      <li>
        BAD STATES
          <span class="green">{{partnerDashboardData?.badStates | number}}</span>
      </li>
      <li>
          CPL
          <span class="purple ">{{partnerDashboardData?.cpl | currency}}</span>
      </li>
      <li>
          CPS
          <span class="blue">${{partnerDashboardData?.cps}}</span>
      </li>
      <li>
        TOTAL COST
        <span class="green">{{partnerDashboardData?.totalCost | currency}}</span>
    </li>
    <li>
      NET EARNINGS
      <span class="orenge">{{partnerDashboardData?.netEarnings | currency}}</span>
  </li>
  <li>
    GROSS EARNINGS
    <span class="red">{{partnerDashboardData?.grossEarnings | currency}}</span>
  </li>
  <li>
    TOTAL SALES
    <span class="purple">{{partnerDashboardData?.totalSales | number}}</span>
  </li>
  <li>
    TOTAL YEARS
    <span class="green">{{partnerDashboardData?.totalYears | number}} Years</span>
  </li>
  <li>
    TOTAL MONTHLY SALES
    <span class="orenge">{{partnerDashboardData?.totalMonthlySales | number}}</span>
  </li>
  <li>
    TOTAL MONTHLY EARNINGS
    <span class="red">{{partnerDashboardData?.totalMonthlyEarnings | currency}}</span>
  </li>
  <li>
    TOTAL YEARLY SALES
    <span class="purple">{{partnerDashboardData?.totalYearlySales | number}}</span>
  </li>
  <li>
    TOTAL MULTI SALES
    <span class="blue">{{partnerDashboardData?.totalMonthlySales | number}}</span>
  </li>
  <li>
    ROI
    <span class="green">{{partnerDashboardData?.roi | number}}%</span>
  </li>
  <li>
    NET CONVERSION
    <span class="orenge">{{partnerDashboardData?.netConversionRate | number}}%</span>
  </li>
  <li>
    GROSS CONVERSION
    <span class="red">{{partnerDashboardData?.grossEarnings | number}}%</span>
  </li>
  <li>
    SCORE
    <span class="purple">{{partnerDashboardData?.score | number}} Points</span>
  </li>
  
  </ul>
  
    <fury-page-layout-content [@fadeInUp]>
      <fury-list name={{filterValue}} [columns]="columns" (filterChange)="onFilterChange($event)">
        <div style="position: relative;" class="filter">
          <button class="filter fury-column-filter" type="button" mat-icon-button (click)="showFilter()">
            <img src="../../../assets/img/filter.png" alt="filter"/>
          </button>
          <div class="filteringprt" *ngIf="isShowFilter">
            <form [formGroup]="filterForm">
            <h3 style="margin: 0;">Filter</h3>
            <mat-form-field appearance="outline">
              <mat-label>Search By</mat-label>
              <mat-select formControlName="searchBy">
                <mat-option *ngFor="let item of serchByValue" [value]="item?.value">{{item.title}}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Search Type</mat-label>
              <mat-select formControlName="searchType">
                <mat-option *ngFor="let item of commonService.searchTypeValue" [value]="item?.value">{{item.title}}</mat-option>
              </mat-select>
            </mat-form-field>
            <div class="btnprt">
              <button mat-button class="can-button" (click)="showFilter()">Cancel</button>
              <button mat-button class="sub-button" (click)="filterChange()">Search</button>
            </div>
          </form>
          </div>
        </div>
        <div class="actions">
          <button class="create"  type="button" [routerLink]="['/lead-partners/partner-add']" mat-mini-fab color="primary">
            <mat-icon>add</mat-icon>
          </button>
        </div>
        <div class="table_container">
          <table [dataSource]="dataSource" mat-table matSort>
              <!-- actions Column -->
              <ng-container matColumnDef="actions" stickyEnd>
                  <th *matHeaderCellDef class="actions-cell" mat-header-cell mat-sort-header>Actions</th>
                  <td *matCellDef="let row;let i=index" class="actions-cell" mat-cell>
                      <button type="button" [matMenuTriggerFor]="actionsMenu" (click)="$event.stopPropagation()"
                          mat-icon-button>
                          <mat-icon>more_horiz</mat-icon>
                      </button>
    
                      <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before">
                        <button mat-menu-item [routerLink]="['/lead-partners/lead-partner-dashboard/'+row?.leadPartnerId]">
                          <span>Partner Dashboard</span>
                      </button>
                          <button mat-menu-item [routerLink]="['/lead-partners/partner-edit/'+row?.leadPartnerId]">
                              <span>Edit</span>
                          </button>
                          <button mat-menu-item [routerLink]="['/lead-partners/partner-content-edit/'+row?.leadPartnerId]">
                            <span>Edit Partner Content</span>
                        </button>
                        <!-- <button mat-menu-item [routerLink]="['/lead-partners/partner-popup-content-edit/'+row?.leadPartnerId]">
                          <span>Edit Popup Content</span>
                      </button> -->
                          <button mat-menu-item (click)="openDialog('delete', row?.leadPartnerId)">
                              <span>Delete</span>
                          </button>
                      </mat-menu>
                  </td>
              </ng-container>
              <ng-container matColumnDef="isActive" stickyEnd>
                <th *matHeaderCellDef mat-header-cell>Status</th>
                <td *matCellDef="let row" mat-cell>
                    <mat-slide-toggle [(ngModel)]="row.isActive" (change)="changeLeadPartnerStatus($event, row)"></mat-slide-toggle>
                </td>
              </ng-container>
    
            <ng-container *ngFor="let column of columns">
              <ng-container [matColumnDef]="column['property']" *ngIf="column.property != 'actions' && column.property != 'isActive'">
                  <th *matHeaderCellDef mat-header-cell mat-sort-header> {{ column.name }}</th>
                  <td *matCellDef="let row" mat-cell>{{ row[column.property] }}</td>
              </ng-container>
            </ng-container>
    
            <tr *matHeaderRowDef="visibleColumns; sticky: true" mat-header-row></tr>
            <tr *matRowDef="let row; columns: visibleColumns | paginate: { id: 'server', itemsPerPage: pageSize, currentPage: pageIndex, totalItems: totalCount };" class="clickable route-animations-elements" mat-row></tr>
          </table>
        </div>
        <div *ngIf="partnerList?.length === 0" style="padding: 10px 0; text-align:center;">
          No Lead Partner found.
        </div>  
       
        <mat-paginator [pageSizeOptions]="[30, 50, 100, 9999]" [pageSize]="pageSize" [length]="totalCount" [pageIndex]="pageIndex" (page)="pageSizeChange($event)"
        showFirstLastButtons
        [selectConfig] = "selectConfig"
        [ngClass]="{'mat-pegig': pageSize === 9999}"
        aria-label="Select page of periodic elements">
    </mat-paginator>
      </fury-list>
  
    </fury-page-layout-content>
  </fury-page-layout>
  



